var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mt-datetime-picker',{attrs:{"type":"date","year-format":"{value} 年","month-format":"{value} 月","date-format":"{value} 日","startDate":_vm.startDate,"endDate":_vm.endDate},on:{"confirm":_vm.confirm},model:{value:(_vm.currDate),callback:function ($$v) {_vm.currDate=$$v},expression:"currDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }